<template>
    <div class="container">
        <div class="type">
            <a-button :type="sourceType == 1 ? 'primary' : ''" @click="chooseSourceType(1)">校内老师</a-button>
            <a-button :type="sourceType == 2 ? 'primary' : ''" @click="chooseSourceType(2)">校外老师</a-button>
        </div>
        <div class="search">
            <div class="search-item">
                老师姓名: <a-input v-model="teacherName" placeholder="请输入" :maxLength="45" style="width: 240px;"></a-input>
                <span style="margin-left:24px;">
                    手机号码: <a-input v-model="mobile" type="tel" placeholder="请输入" :maxLength="11"
                        style="width: 240px;"></a-input>
                </span>
                <span style="margin: 0 32px 0 24px;">
                    审核状态
                    <a-select placeholder="请选择" v-model="status" style="width: 200px;" allowClear>
                        <a-select-option value="3">待提交</a-select-option>
                        <a-select-option value="0">待审核</a-select-option>
                        <a-select-option value="4">初审通过</a-select-option>
                        <a-select-option value="5">复审通过</a-select-option>
                        <a-select-option value="1">审核通过</a-select-option>
                        <a-select-option value="2">审核不通过</a-select-option>
                    </a-select>
                </span>
                <a-button type="primary" @click="search()" style="margin-right: 12px;">查询</a-button>
                <a-button @click="reset()">重置</a-button>
            </div>
            <!-- 操作 -->
            <div class="list-oper" v-show="sourceType == 1">
                <a-button type="primary" icon="plus" @click="openFormDrawer()">新建</a-button>
                <!-- 学校和课程方拥有导入权限 -->
                <a-button class="import-excel" type="primary" icon="plus"
                    @click="$refs.teacherFile.init()">导入老师</a-button>
                <a-button class="import-excel" type="primary" @click="exportTeacher()">导出老师</a-button>
            </div>
        </div>
        <div class="p24">
            <div class="empty" v-if="!teacherList.length">
                <a-empty></a-empty>
            </div>
            <div class="teacher-list" v-else>
                <template>
                    <a v-for="item in teacherList" :key="item.id">
                        <div class="item" @click="showDetail(item.userId)">
                            <div class="avatar">
                                <img :src="item.protraitPhotoUrl[0].fileUrl" v-if="item.protraitPhotoUrl">
                                <img v-else src="https://static.khsdb.com/operation/images/seat.png"
                                    style="width: 60px; height: 60px;">
                            </div>
                            <div class="info">
                                <div class="title">
                                    <b>{{ item.nickname }}</b>
                                    <div>ID:{{ item.id }}</div>
                                </div>
                                <div class="text">
                                    <div>
                                        <span class="label">手机号</span>{{ item.mobile }}
                                    </div>
                                    <div>
                                        <span class="label">单位名称</span>{{ item.sourceType == 1 ? item.schoolName :
                                            '机构名称' }}
                                    </div>
                                    <div>
                                        <span class="label">审核状态</span>
                                        <a-tag style="border-radius: 50%; vertical-align: middle; padding: 3px" :color="item.statusText === '审核通过'
                                            ? '#68CC2E'
                                            : item.statusText === '审核不通过'
                                                ? '#FA5151'
                                                : '#FFA91F'
                                            ">
                                        </a-tag>
                                        {{ item.statusText }}
                                    </div>
                                    <div style="display: flex">
                                        <span class="label">授课课程</span>
                                        <a-popover>
                                            <template slot="content">
                                                <p>{{ item.applyCourseType }}</p>
                                            </template>
                                            <div class="ellipsis">{{ item.applyCourseType }}</div>
                                        </a-popover>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </template>
                <div class="pagination">
                    <a-pagination v-model="currentPage" :defaultPageSize="12" :total="total" show-quick-jumper
                        @change="onChange" :show-total="total => `总共 ${total} 位`" />
                </div>
            </div>
        </div>
        <!-- 老师导入 -->
        <teacher-file-modal ref="teacherFile" @refreshList="getList()"></teacher-file-modal>
        <!-- 老师详情 -->
        <SchoolTeacherDetail v-if="showDrawer" :showDrawer.sync="showDrawer" @refresh="getList()" @edit="openFormDrawer"
            :teacherUserId="teacherUserId" :readOnly="sourceType == 2">
        </SchoolTeacherDetail>
        <!-- 新建/修改 -->
        <SchoolTeacherForm v-show="formDrawer" :showDrawer.sync="formDrawer" @refresh="getList()" :userId="userId"
            ref="formRef">
        </SchoolTeacherForm>
    </div>
</template>

<script>
import teacher from '../../api/teacher'
import TeacherFileModal from './components/TeacherFileModal'
import SchoolTeacherDetail from './components/SchoolTeacherDetail.vue'
import SchoolTeacherForm from './components/SchoolTeacherForm'
export default {
    name: 'SchoolTeacherList',
    data() {
        return {
            teacherName: '',
            mobile: '',
            teacherList: [],
            total: 0,
            currentPage: 1,
            showDrawer: false,
            formDrawer: false,
            teacherUserId: null,
            userId: null,
            sourceType: 1,
            status: undefined
        }
    },
    created() {
        this.getList()
    },
    components: {
        SchoolTeacherDetail,
        SchoolTeacherForm,
        TeacherFileModal
    },
    methods: {
        search() {
            this.currentPage = 1
            this.getList()
        },
        showDetail(id) {
            this.showDrawer = true
            this.teacherUserId = id
        },
        reset() {
            this.teacherName = ''
            this.mobile = ''
            this.status = undefined
        },
        getList() {
            let params = {
                pageSize: 12,
                status: this.status,
                currentPage: this.currentPage,
                keyword: this.teacherName,
                teacherMobile: this.mobile,
                sourceType: this.sourceType
            }
            teacher.getSchoolTeacherList(params).then(res => {
                this.total = res.data.pagination.total
                this.teacherList = res.data.list
            })
        },
        onChange(e) {
            this.currentPage = e
            this.getList()
        },
        openFormDrawer(id) {
            this.formDrawer = true
            this.userId = id ? id : null
            this.$refs.formRef.backTop()
            if (id) {
                this.$refs.formRef.init(id)
            }
        },
        chooseSourceType(num) {
            if (this.sourceType == num) return
            this.currentPage = 1
            this.sourceType = num
            this.getList()
        },
        // 导出老师
        exportTeacher() {
            let _this = this
            this.$confirm({
                title: '注意',
                okText: '确定',
                cancelText: '取消',
                icon: 'exclamation-circle',
                content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
                onOk() {
                    _this.$store.dispatch('getUserInfo').then((userInfo) => {
                        // console.log(userInfo)
                        let params = {}
                        if (userInfo.roleId == 3) {
                            params = { schoolId: userInfo.schoolId }
                        } else if (userInfo.roleId == 4) {
                            params = { institutionId: userInfo.institutionId }
                        }
                        Object.assign(params, _this.queryParam)
                        teacher.exportTeacher(params).then((res) => {
                            window.location.href = res.data
                        })
                    })
                },
            })
        },
    }
}
</script>

<style lang="less" scoped>
.container {
    width: calc(100% - 40px);
    background-color: #fff;
    margin: 20px;
    box-sizing: border-box;
}

.type {
    padding: 24px 24px 16px;

    button {
        border-radius: 16px;
        padding: 0 19px;
        margin-right: 12px;
    }
}

.search {
    padding: 0 24px 24px;
    border-bottom: 1px solid #E0E2E4;

    .search-item {
        color: #171A1D;
        font-size: 14px;
    }

}

.p24 {
    padding: 24px;
    width: 100%;
}

.empty {
    height: calc(100vh - 390px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.teacher-list {
    padding-bottom: 32px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    min-width: 1100px;

    @media only screen and (max-width: 1600px) {
        a {
            width: 32.5%;
            margin-right: 1.25%;
        }

        a:nth-child(3n) {
            margin-right: 0;
        }
    }

    @media only screen and (min-width: 1601px) {
        a {
            width: 24%;
            margin-right: 1.33%;
        }

        a:nth-child(4n) {
            margin-right: 0;
        }
    }

    a {
        display: block;
        margin-bottom: 20px;

        .item {
            display: flex;
            border-radius: 10px;
            border: 1px solid #E3E3E3;
            display: flex;

            .avatar {
                display: flex;
                justify-content: center;
                align-items: center;
                min-width: 100px;
                height: 140px;
                background-color: #ebebed;
                border-radius: 10px 0 0 10px;
                margin-right: 22px;
                object-fit: cover;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 10px 0 0 10px;
                    aspect-ratio: 413 / 626;
                    object-fit: cover;
                }
            }

            .info {
                color: #171A1D;
                padding-right: 12px;
                flex: 1;

                .title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 10px;

                    b {
                        font-size: 16px;
                        font-weight: 500;
                    }

                    div {
                        border: 1px solid #C7C8C9;
                        color: #C7C8C9;
                        padding: 2px 8px;
                        font-size: 12px;
                        line-height: 12px;
                        height: 100%;
                        border-radius: 9px;
                    }
                }

                .text {
                    margin-top: 15px;
                    height: calc(100% - 60px);
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;

                    div {
                        box-sizing: border-box;
                        line-height: 14px;
                        font-size: 12px;

                        .label {
                            display: inline-block;
                            min-width: 66px;
                            color: rgba(23, 26, 29, 0.6);
                            margin-right: 16px;
                        }
                    }
                }
            }
        }
    }



    .pagination {
        margin-top: 12px;
        width: 100%;
        text-align: center;

        ::v-deep .ant-pagination-item {
            margin: 0 4px !important;
        }

        ::v-deep .ant-pagination-options-quick-jumper {
            margin-left: 12px !important;
        }
    }
}

.list-oper {
    margin-top: 20px;

    button {
        margin-right: 20px;
    }
}

.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 130px;
}
</style>